const submit = document.querySelector('div.mini_cart_footer.js_cart_footer > button');
if (submit != null) {
  submit.addEventListener('click', injectDiscount);
}
function injectDiscount(event) {
  let discount = document.querySelector('#Cartdiscode').value;
  event.preventDefault();
  if (discount == 0) {
    discount = 'NEWCLIENTS';
  }
  console.log(discount);
  document.querySelector('#Cartdiscode').value = discount;
  submit.removeEventListener('click', injectDiscount, false);
  submit.click();
}
document.addEventListener('cart:refreshed', function () {
  // Make a fetch call to update all informations after cart update
  fetch("/cart.js", {
    "credentials": "same-origin",
    "headers": {
      "cache-control": "no-cache"
    }
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    let cart_total = data.total_price / 100;
    initProgressBar(cart_total);

    // Get the free product section infos
    let free_product_amount = parseInt(document.querySelector('.mini_cart_upsell.free_product').getAttribute('data-amount')); // Get the amount defined in the settings to get the free product
    let free_product_section = document.querySelector('.mini_cart_upsell.free_product');
    let flkty = Flickity.data('.free_product .mini_cart_upsell_items');

    // Create an array to get only the product id of products which are in the cart drawer
    let cartVariants = data.items.map(function (variant) {
      return variant.id;
    });

    // Create an array to get only the product id of product which are on the free product section collection
    let collectionVariantsList = document.querySelectorAll('.free_product .upsell_item');
    let collectionVariants = Array.from(collectionVariantsList).map(function (variant) {
      return parseInt(variant.getAttribute('data-variant-id'));
    });

    // Check if the two arrays have matching id
    let matchingProductId = collectionVariants.filter(function (obj) {
      return cartVariants.indexOf(obj) !== -1;
    });

    // Display the free product section if cart total is higher than the free product amount 
    // AND if the two arrays (cartVariants and collectionVariants) doesn't have matching element
    if (cart_total > free_product_amount && matchingProductId.length == 0) {
      free_product_section.classList.add('active');
      flkty.reloadCells();
      flkty.resize();
    } else {
      free_product_section.classList.remove('active');
    }
  }).catch(function (error) {
    console.log(error);
  });
});
document.addEventListener('DOMContentLoaded', function () {
  let html = document.querySelector('html');
  if (html.classList.contains('template-cart')) {
    let cart_page_total = document.querySelector('.cart__footer .cart_tot_price').getAttribute('data-price');
    let cart_total = cart_page_total / 100;
    initProgressBar(cart_total);
  }
});
function initProgressBar(cart_total) {
  let progressbar = document.querySelector(".cart-progressbar__progress-bar");
  let levelsProgressBar = document.querySelectorAll(".cart-progressbar__level"); // All levels
  let levelsNumber = levelsProgressBar.length; // Number of levels in the progress bar
  let levelsWidth = 100 / (levelsNumber + 1) / 100; // Width of each levels in the progress bar in percent

  // Get the total cart

  /*
   * CALCULATE PERCENTAGE OF THE PRICE
   * POSITION IN THE CURRENT LEVEL
   */

  let prev_step = 0;
  let next_step = 100;

  // Make a loop to define prev_step and next_step depending on the cart total
  for (var i = 0; i < levelsProgressBar.length; i++) {
    let level_value = levelsProgressBar[i].querySelector(".cart-progressbar__price").innerHTML.replace("€", ""); // Get the price level value and remove '€‘
    let level_value_int = parseInt(level_value); // Convert level_value into a number

    // Determine prev_step and next_step values depending on the cart total
    if (level_value_int < cart_total && level_value_int > prev_step) {
      prev_step = level_value_int;
    } else if (level_value_int > cart_total && level_value_int < next_step) {
      next_step = level_value_int;
    }
  }

  // Calculate position (percentage) in the current level
  let pricePositionInStep;
  if (next_step != 1000) {
    pricePositionInStep = (cart_total - prev_step) / (next_step - prev_step);
  } else {
    pricePositionInStep = (cart_total - prev_step) / (next_step - prev_step);
  }

  /*
   * DEFINE THE PROGRESS BAR WIDTH
   */

  // Get the level index where the cart total are
  let stepsValues = document.querySelector(".cart-progressbar").getAttribute("data-steps"); // Get the data-attribute where are all steps values
  let stepsValuesArray = stepsValues.split(","); // Make an array with the values
  let lastStep = stepsValuesArray.slice(-1); // Get the last step in array to make a condition on the bar width

  // Convert each value of the array into a number
  stepsValuesArray = stepsValuesArray.map(value => parseInt(value));

  // Make +1 on the index to multiply easily according to the different levels on the progress bar
  let prevStepIndex = stepsValuesArray.indexOf(prev_step) + 1;
  let pricePositionInBar = (pricePositionInStep * levelsWidth + levelsWidth * prevStepIndex) * 100;

  // Apply pricePositionInBar in the progress bar width
  if (cart_total < lastStep) {
    progressbar.style.width = pricePositionInBar + "%";
  } else {
    // If the cart total is superior of the last element in the array, the bar width will be 100%
    progressbar.style.width = "100%";
  }

  /*
   * DISPLAY TEXT BELOW THE BAR
   */

  // Display the corresponding text below the bar
  let sentences = document.querySelectorAll(".cart-progressbar__description");
  for (var i = 0; i < sentences.length; i++) {
    sentences[i].style.display = "none"; // Display none all the text which is visible
  }

  let sentenceToDisplay = document.querySelector(`.cart-progressbar__description[data-step="${next_step}"]`); // Get the next text to display
  if (sentenceToDisplay != undefined) {
    sentenceToDisplay.style.display = "block"; // Make the text visible

    // And inject the remaining amount before the next discount
    let remainingAmount = (next_step - cart_total).toFixed(2);
    let remainingAmountContainer = sentenceToDisplay.querySelector(".cart-progressbar__remaining-amount");
    remainingAmountContainer.innerHTML = remainingAmount;
  }
}